import { useTenantLink } from '../../hooks/useTenantLink';

export default function TenantLink ({ to = '/', tenant, children, ...rest }) {
  const getTenantLink = useTenantLink();
  const href = getTenantLink(to, tenant);

  return (
    <a href={href} {...rest}>
      {children}
    </a>
  );
};
